import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-warning",
  "use": "status-warning-usage",
  "viewBox": "0 0 76.03 76.03",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 76.03 76.03\" id=\"status-warning\"><title>资源 4</title><g data-name=\"图层 2\"><path d=\"M76 38a38 38 0 1 0-38 38 38 38 0 0 0 38-38zm-35.39 4.08a2.55 2.55 0 1 1-5.1 0V22.81a2.55 2.55 0 0 1 5.1 0zm.62 10.17a3 3 0 0 1-3.19 3 3 3 0 1 1 0-6.07 3 3 0 0 1 3.19 3.07z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/status-warning.svg
// module id = KvwK
// module chunks = 6